import { render } from "./VerifyTel.vue?vue&type=template&id=ad1e4e8e&scoped=true"
import script from "./VerifyTel.vue?vue&type=script&lang=js"
export * from "./VerifyTel.vue?vue&type=script&lang=js"

import "./VerifyTel.vue?vue&type=style&index=0&id=ad1e4e8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad1e4e8e"]])

export default __exports__